import React from 'react';
import {
    Footer as CmpFooter
} from '../components';


const Footer = ({sub=false}) => {
    return (
        <>
            <CmpFooter sub={sub} />
        </>
    );
}

export default Footer;
